class Utils {
    static addLeadingZero(value) {
        const positive = value >= 0
        value = Math.abs(value)
        const asStr = value > 9 ? value : '0' + value
        return positive ? asStr : '-' + asStr
    }

    static formatSecondsToHours(rawSeconds) {
        let remaining = rawSeconds

        const hours = parseInt(remaining / (60 * 60))
        remaining -= hours * 60 * 60

        const minutes = parseInt(remaining / 60)
        remaining -= minutes * 60

        const seconds = remaining

        return `${this.addLeadingZero(hours)}:${this.addLeadingZero(minutes)}:${this.addLeadingZero(seconds)}`
    }

    static isSameOrChild(parent, el) {
        return parent === el || parent.contains(el)
    }
}

RO.classes.Utils = Utils